<app-header></app-header>
<div class="container-fluid">
  <div class="row pt-5">
    <div class="col-12">
      <app-pictures-article></app-pictures-article>
    </div>
  </div>
</div>
<app-footer></app-footer>
